import Vue from 'vue';

Vue.component('career-content-body-component', {
    mounted() {
        this.$nextTick(() => {
            this.processContentBody();
        });
    },
    methods: {
        processContentBody() {
            const contentBody = this.$el.querySelector('div') || this.$el;

            if (!contentBody) return;

            this.processJobInfoElements(contentBody);
            this.processCareerFooterInfoElements(contentBody);
        },

        processJobInfoElements(contentBody) {
            const children = Array.from(contentBody.children);

            for (let i = 0; i < children.length; i++) {
                const currentElement = children[i];

                if (currentElement.classList.contains('job-info__subtitle')) {
                    const nextElement = children[i + 1];

                    if (
                        nextElement &&
                        nextElement.classList.contains('job-info__text')
                    ) {
                        const wrapper = document.createElement('div');
                        wrapper.className = 'job-info__item';

                        currentElement.parentNode.insertBefore(
                            wrapper,
                            currentElement,
                        );

                        wrapper.appendChild(currentElement);
                        wrapper.appendChild(nextElement);

                        children.splice(i, 2, wrapper);
                        i--;
                    }
                }
            }
        },

        processCareerFooterInfoElements(contentBody) {
            const footerInfoElements = contentBody.querySelectorAll(
                '.career-footer-info',
            );

            if (footerInfoElements.length === 0) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'career-footer-info-holder';

            const firstFooterElement = footerInfoElements[0];

            firstFooterElement.parentNode.insertBefore(
                wrapper,
                firstFooterElement,
            );

            footerInfoElements.forEach((element) => {
                wrapper.appendChild(element);
            });
        },
    },
});
